import { render, staticRenderFns } from "./DeviceRomStorageUpdateBox.vue?vue&type=template&id=15ff0c34"
import script from "./DeviceRomStorageUpdateBox.vue?vue&type=script&lang=js"
export * from "./DeviceRomStorageUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports